import { Flex, useColorModeValue } from '@chakra-ui/react';
import { Home } from './Home/Home';
import { Header } from './Header/Header';

export const App = () => {
  const formBackground = useColorModeValue('gray.100', 'gray.700');

  return (
    <Flex height="100vh" direction="column" flex="1" bg={formBackground}>
      <Header />
      <Home />
    </Flex>
  );
};
